import { i18n } from '@lingui/core';
import { TSupportedLocales } from 'types';

export const FLEXI_LOAN_BOUNDS_DE = {
  min: 1000,
  max: 500000,
};

export const FLEXI_LOAN_BOUNDS_UK = {
  min: 1000,
  max: 1000000,
};

export const getFormattedProductBounds = (
  currency: {
    min: number;
    max: number;
  },
  locale: TSupportedLocales,
) => {
  if (locale === 'en-GB')
    return {
      min: i18n.number(currency.min, {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
      max: i18n.number(currency.max, {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
    };
  return {
    min: i18n.number(currency.min, {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
    max: i18n.number(currency.max, {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
  };
};
